export default "/images/global-min.png?bba0ad0625b7321ffe79086115e169a2";